import { c as _c } from "react/compiler-runtime";
import { CardSkeleton } from "@components/common/skeleton-loading/card-skeleton";
import { GroupCard } from "@components/group-card/group-card";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { CARD_COLUMN_CONFIG, CARD_MIN_COLUMN_WIDTH } from "@components/virtualized/virtualized-grid-utils";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { useAppSelector } from "@store/store-helper";
/**
 * Lists all the available groups in the company as cards.
 */
export function GroupsTiles(t0) {
  const $ = _c(3);
  const {
    groups
  } = t0;
  const {
    isFetchingGroups
  } = useAppSelector(fetchingGroupsFlagsSelector);
  let t1;
  if ($[0] !== groups || $[1] !== isFetchingGroups) {
    t1 = <VirtualizedGrid key={groups.length} items={groups} isLoading={isFetchingGroups} columnConfig={CARD_COLUMN_CONFIG} minColumnWidth={CARD_MIN_COLUMN_WIDTH} renderSkeletonItem={_temp} renderItem={_temp2} />;
    $[0] = groups;
    $[1] = isFetchingGroups;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp2(group) {
  return <GroupCard key={group.id} group={group} />;
}
function _temp(i) {
  return <CardSkeleton key={`skeleton-group-${i}`} type="group" />;
}